var map = {
	"./featured-banner.de-CH.json": 1140,
	"./featured-banner.de-DE.json": 1141,
	"./featured-banner.en-CA.json": 1142,
	"./featured-banner.en-GB.json": 1143,
	"./featured-banner.en-IN.json": 1144,
	"./featured-banner.en-ME.json": 1145,
	"./featured-banner.en-US.json": 1146,
	"./featured-banner.es-EM.json": 1147,
	"./featured-banner.es-ES.json": 1148,
	"./featured-banner.fr-BE.json": 1149,
	"./featured-banner.fr-CA.json": 1150,
	"./featured-banner.fr-CH.json": 1151,
	"./featured-banner.nl-BE.json": 1152,
	"./featured-banner.nl-NL.json": 1153,
	"./featured-banner.pl-PL.json": 1154,
	"./featured-banner.pt-BR.json": 1155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1139;